import React from "react";
import './pagination.css';

const ProspectPagination = ({ page, refetch, customers, customer }) => {
  // normaliza a origem
  const resp = customers || customer;
  const meta = resp?.data?.meta || {};

  const current = Number(meta.current_page || page.current || 1);
  const total = Number(meta.last_page || meta.total_pages || 1);

  const canPrev = current > 1;
  const canNext = current < total;

  const go = (e, p) => {
    e.preventDefault();
    if (!p || p === page.current || p < 1 || p > total) return;
    page.current = p;
    refetch();
  };

  const prev = (e) => canPrev && go(e, current - 1);
  const next = (e) => canNext && go(e, current + 1);

  // Gera: 1 … (c-1) c (c+1) … total
  const getItems = (c, t) => {
    if (!t || t < 1) return [];
    if (t <= 7) return Array.from({ length: t }, (_, i) => i + 1);

    const items = [1];
    const left = Math.max(2, c - 1);
    const right = Math.min(t - 1, c + 1);

    if (left > 2) items.push("...");
    for (let i = left; i <= right; i++) items.push(i);
    if (right < t - 1) items.push("...");
    items.push(t);

    return items;
  };

  const items = getItems(current, total);

  return (
    <div className="prospect__pagination">
      <div className="prospect__pagination-previous">
        <a
          href=""
          onClick={prev}
          className={`prospect__pagination-link ${!canPrev ? "prospect__pagination-link-inactive" : ""}`.trim()}
          aria-disabled={!canPrev}
        >
          Anterior
        </a>
      </div>

      <div className="prospect__pagination-numbers">
        {items.map((it, idx) =>
          typeof it === "number" ? (
            <a
              key={idx}
              href=""
              onClick={(e) => go(e, it)}
              className={`prospect__pagination-link ${it === current ? "prospect__pagination-current" : ""}`.trim()}
              aria-current={it === current ? "page" : undefined}
            >
              {it}
            </a>
          ) : (
            <span key={idx} className="text-color" style={{ padding: "0 6px" }}>
              …
            </span>
          )
        )}
      </div>

      <div className="prospect__pagination-next">
        <a
          href=""
          onClick={next}
          className={`prospect__pagination-link ${!canNext ? "prospect__pagination-link-inactive" : ""}`.trim()}
          aria-disabled={!canNext}
        >
          Próximo 
        </a>
      </div>
    </div>
  );
};

export default ProspectPagination;
